<script>
import {mapGetters} from "vuex";
import controller from "../../scripts/controller/controller.js";

export default {
	props: {
		// link to load data from (String)
		// or data object itself (Object)
		dataSource: {
			type: [Object, String],
			default: undefined
		},

		// Bitrix component id
		// required by Bitrix to determine component instance for AJAX requests
		// (dataSource link often simpty refers to page containing multiple components)
		bxajaxid: {
			type: String,
			default: undefined
		},

		// immediately load data on "created" hook
		// if dataSource is a link
		loadOnInit: {
			type: Boolean,
			default: true
		}
	},

	data() {
		return {
			// bxajaxid which is finally computed after processing props and slots
			localBxajaxid: null,

			// loading state
			loading: false
		};
	},

	computed: {
		...mapGetters({
			isAuth: 'user/isAuthUser',
		}),

		userData() {
			return this.$store.state.user;
		},

		componentName() {
			let path = this.$options.__file;
			if (path) {
				return path.slice(path.lastIndexOf('/') + 1, path.lastIndexOf('.'));
			}
			return null;
		}
	},

	watch: {
		dataSource() {
			// try to load using props
			this.init(this.bxajaxid, this.dataSource);
		}
	},

	created() {
		// try to load using props
		this.init(this.bxajaxid, this.dataSource);
		const readSlot = (item) => {
			if (item?.props) {
				const bxajaxid = item.props['bxajaxid'];
				const dataSource = item.props['data-source'];
				if (dataSource) {
					this.init(bxajaxid, dataSource);
				}
			}
		};

		// try to load using slots
		if (this.$slots?.source) {
			this.$slots?.source().forEach((item) => {
				readSlot(item);
				if (item?.children && Array.isArray(item?.children)) {
					item.children.forEach(readSlot);
				}
			});
		}
	},

	methods: {
		userCheckAuth() {
			if (!this.isAuth) {
				controller.openModal({
					className: 'modal--sm',
					//url: '/auth/login.php'
					url: '/local/assets/dist/markup/modal-sign-in.html'
				});
				return false;
			}
			return true;
		},

		dataSet(data, options) {
			console.info(`${this.componentName}: warning: v-source-mixin is used but sourceSet is not implemented in your component`, data, options);
		},

		setSeoParams(seoData, remote) {
			if (remote) {
				history.pushState(remote, (seoData.title || ''), remote);
			}

			if (seoData) {
				if (document.title !== seoData.title) {
					document.title = seoData.title;
				}
				if (!document.querySelector('meta[name="description"]')) {
					let meta = document.createElement('meta');
					meta.name = 'description';
					document.getElementsByTagName('head')[0].appendChild(meta);
				}
				if (!document.querySelector('meta[name="keywords"]')) {
					let meta = document.createElement('meta');
					meta.name = 'keywords';
					document.getElementsByTagName('head')[0].appendChild(meta);
				}
				if (seoData.robots && document.querySelector('meta[name="robots"]')) {
					document.querySelector('meta[name="robots"]').setAttribute('content', seoData.robots);
				} else if (seoData.robots && !document.querySelector('meta[name="robots"]')) {
					let meta = document.createElement('meta');
					meta.name = 'robots';
					document.getElementsByTagName('head')[0].appendChild(meta);
					document.querySelector('meta[name="robots"]').setAttribute('content', seoData.robots);
				} else if (!seoData.robots && document.querySelector('meta[name="robots"]')) {
					document.querySelector('meta[name="robots"]').remove();
				}
				if (seoData.canonical && document.querySelector('link[rel="canonical"]')) {
					document.querySelector('link[rel="canonical"]').setAttribute('href', seoData.canonical);
				} else if (seoData.canonical && !document.querySelector('link[rel="canonical"]')) {
					let meta = document.createElement('link');
					meta.rel = 'canonical';
					meta.href = seoData.canonical;
					document.getElementsByTagName('head')[0].appendChild(meta);
				} else if (!seoData.canonical && document.querySelector('link[rel="canonical"]')) {
					document.querySelector('link[rel="canonical"]').remove();
				}
				document.querySelector('meta[name="description"]').setAttribute('content', seoData.description);
				document.querySelector('meta[name="keywords"]').setAttribute('content', seoData.keywords);
				if (document.querySelector('#bx-panel')) {
					document.querySelector('#bx-panel').remove();
				}
			}
		},

		convertData(staticDataSource) {
			if (!staticDataSource || typeof staticDataSource == 'undefined') {
				return null;
			}
			if (typeof staticDataSource === 'string') {
				return staticDataSource;
			}
			if (typeof (staticDataSource.encoded) == 'undefined') {
				return staticDataSource;
			}
			return JSON.parse(atob(staticDataSource.encoded));
		},

		async dataLoad(options = {}, dataSetOptions) {
			// use this.loading to set preloaders if needed
			this.loading = true;
			// check arguments
			if (!options || typeof options !== 'object' || !options.url) {
				console.warn(`${this.componentName}: warning: dataLoad options arg is wrong`, options);
			}
			// convert any options.data to transfer as FormData
			let formattedData =(options.data instanceof FormData)  ?  options.data : new FormData();
			// set bxajaxid if present
			if (this.localBxajaxid) {
				formattedData.set('bxajaxid', this.localBxajaxid);
			}
			if (!(options.data instanceof FormData) && options.data) {

				let makeFormData = (data, parentKey) => {
					if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
						Object.keys(data).forEach((key) => {
							makeFormData(data[key], parentKey ? `${parentKey}[${key}]` : key);
						});
					} else {
						formattedData.append(parentKey, data == null ? '' : data);
					}
				};
				makeFormData(options.data);
			}



			// set min delay to ensure preloader fadein/fadeout plays fine (<transition name="fade"> speed is 250ms)
			const delayPromise = new Promise((resolve) => {
				options.delay ? setTimeout(resolve, 250) : resolve();
			});

			try {
				// create request
				const requestPromise = fetch(options.url, {
					method: 'POST',
					body: formattedData
				});
				// wait for both promises
				const [response] = await Promise.all([requestPromise, delayPromise]);
				// handle response
				if (!response.ok) {
					console.warn(`${this.componentName}: AJAX request failed`, response);
				} else {
					let data = this.convertData(await response.json());
					console.log(`${this.componentName}: AJAX request completed`, data);
					if (data.redirect) {
						window.location.href = data.redirect;
					}
					if (data.reload) {
						window.location.reload(true);
					}
					if (data.displayURL) {
						window.history.replaceState(null, null, data.displayURL);
					}
					this.dataSet(data, dataSetOptions);
					if (!data.redirect && !data.reload) {
						this.loading = false;
					}
				}
			} catch (e) {
				console.warn(`${this.componentName}: AJAX request failed`, e);
			}
			this.loading = false;
		},

		init(bxajaxid, dataSource) {
			if (typeof bxajaxid !== 'undefined') {
				this.localBxajaxid = bxajaxid;
			}
			if (typeof dataSource === 'string') {
				if (this.loadOnInit) {
					this.dataLoad({url: dataSource});
				}
			} else if (typeof dataSource !== 'undefined') {
				this.dataSet(this.convertData(dataSource));
			}
		},

		openModalConfirm(options){
			controller.closeMobFilter();
			controller.openModal({
				className: "modal--right",
				component: {
					name: 'v-form-action',
					props: {
						align: "center",
						dataSource: options
					}
				}
			});
		}
	}
};
</script>